var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenuCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0906 19.4736L3.77668 3.15969C3.52217 2.90518 3.37919 2.55999 3.37919 2.20005C3.37919 1.84011 3.52217 1.49492 3.77668 1.24041C4.0312 0.985892 4.37639 0.842908 4.73633 0.842908C5.09626 0.842908 5.44146 0.985892 5.69597 1.24041L22.0099 17.5544C22.2644 17.8089 22.4074 18.1541 22.4074 18.514C22.4074 18.8739 22.2644 19.2191 22.0099 19.4736C21.7554 19.7282 21.4102 19.8711 21.0503 19.8711C20.6903 19.8711 20.3451 19.7282 20.0906 19.4736Z",
    fill: "#FAD762"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0093 3.15985L5.69534 19.4738C5.44082 19.7283 5.09563 19.8713 4.7357 19.8713C4.37576 19.8713 4.03056 19.7283 3.77605 19.4738C3.52154 19.2193 3.37855 18.8741 3.37855 18.5142C3.37855 18.1542 3.52154 17.809 3.77605 17.5545L20.09 1.24057C20.3445 0.986052 20.6897 0.843068 21.0496 0.843067C21.4096 0.843067 21.7548 0.986053 22.0093 1.24057C22.2638 1.49508 22.4068 1.84027 22.4068 2.20021C22.4068 2.56015 22.2638 2.90534 22.0093 3.15985Z",
    fill: "#FAD762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuCloseIcon);
export default __webpack_public_path__ + "static/media/burgerMenuClose_icon.45c30867b1bde4a873e0be6e6df5dfa3.svg";
export { ForwardRef as ReactComponent };